export const gift = {
    gift_title: 'Ton évolution',
    gift_points_1 : 'Tu as',
    gift_points_2 : 'points',
    gift_find_gift: 'Trouver mon cadeau',
    milestone: "Étape",
    milestone_passed: "La date limite de ce questionnaire est dépassée.",
    milestone_available: "Le questionnaire était disponible pendant cette période.",
    milestone_soon: "Ce questionnaire sera disponible dans {{count}} jour{{plural}}.",
    milestone_reminder: "Vous recevrez un rappel par {{methods}}.",
}